<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
@if (showSearchBox$ | async) {
  <div class="blackout active js-container-search-modal floating-search" (click)="closeByContainer($event)">
    <cx-searchbox (_onCloseModal)="closeBySearchButton()"></cx-searchbox>
  </div>
}

@if ({
  hasSearch: hasSearch$ | async,
  currentFreeTextSearch: currentFreeTextSearch$ | async,
  }; as contentPage) {
  <div *limitUp="DEVICE_SIZE.DESKTOP" class="fixed-search">
    <cx-searchbox></cx-searchbox>
  </div>
  <div *smallerThan="DEVICE_SIZE.DESKTOP" class="container-fake-input d-none d-sm-flex">
    <button type="button" class="btn-input" (click)="open()">
      @if (contentPage?.hasSearch === BOOLEAN_TO_ASYNCS.FALSE) {
        {{ 'searchBox.placeholder' | cxTranslate }}
      } @else {
        {{ contentPage.currentFreeTextSearch }}
      }
    </button>
    @if (contentPage?.hasSearch === BOOLEAN_TO_ASYNCS.FALSE) {
      <button type="button" class="btn-action" (click)="open()">
        <span class="material-symbols-outlined"> search </span>
      </button>
    } @else {
      <button type="button" class="btn-action" (click)="clearSearch()">
        <span class="material-symbols-outlined text-danger"> close </span>
      </button>
    }
  </div>
  <div class="d-flex d-sm-none w-100">
    <button type="button" class="btn-search btn-action" (click)="open()">
      <span class="material-symbols-outlined"> search </span>
    </button>
  </div>
}
